import React from "react";
import { Box, Pagination, useTheme, useMediaQuery } from "@mui/material";

export default function Paginator({ page, setPage, pages }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  if (pages <= 1) return null;
  
  return (
    <Box sx={{ mt: 3, display: "flex", justifyContent: "center" }}>
      <Pagination 
        count={pages} 
        page={page} 
        onChange={(e, p) => setPage(p)} 
        color="primary" 
        size={isMobile ? "small" : "medium"}
        siblingCount={isMobile ? 0 : 1}
      />
    </Box>
  );
}